export default function Features() {
  const features = [
    {
      title: "AI Natural Language Detection",
      desc: "Detects service type and urgency from user chat automatically."
    },
    {
      title: "GPS-Based Helper Matching",
      desc: "Finds the nearest available helper based on real-time location."
    },
    {
      title: "Auto Reassignment Logic",
      desc: "If helper rejects, system automatically assigns next best option."
    },
    {
      title: "Admin Analytics Dashboard",
      desc: "Monitor bookings, active helpers and service performance."
    }
  ];

  return (
    <div className="py-20 px-6 md:px-16 bg-gray-50">
      
      <h2 className="text-4xl font-extrabold text-center mb-4">
        Core System Features
      </h2>
      <p className="text-gray-600 text-center mb-14">
        Advanced automation ensures fast, reliable and intelligent service management.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {features.map((item, index) => (
          <div
            key={index}
            className="feature-card p-8 bg-white rounded-2xl shadow-md transition-all duration-500 cursor-pointer"
          >
            <div className="icon-box w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-6 text-2xl transition-all duration-500">
              🤖
            </div>

            <h3 className="text-xl font-bold mb-3">
              {item.title}
            </h3>

            <p className="text-gray-600">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
